import { render, staticRenderFns } from "./registerGzh.vue?vue&type=template&id=fddc5372&scoped=true"
import script from "./registerGzh.vue?vue&type=script&lang=js"
export * from "./registerGzh.vue?vue&type=script&lang=js"
import style0 from "./registerGzh.vue?vue&type=style&index=0&id=fddc5372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddc5372",
  null
  
)

export default component.exports